"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceAssetsService = exports.UserAssetsService = exports.ApiGateway = void 0;
const tslib_1 = require("tslib");
const inversify_1 = require("inversify");
const ui_core_api_gateway_1 = require("@desygner/ui-core-api-gateway");
Object.defineProperty(exports, "ApiGateway", { enumerable: true, get: function () { return ui_core_api_gateway_1.ApiGateway; } });
require("reflect-metadata");
const assets_interfaces_1 = require("./assets.interfaces");
let AssetService = class AssetService {
    constructor(resource, apiGateway) {
        this.resource = resource;
        this.apiGateway = apiGateway;
        this.endpointBase = `brand/companies/${this.apiGateway.company}`;
        this.cache = new Map();
    }
    /**
     * Creates folders in the assets or library.
     * @returns {Promise<string>} The result of the API request.
     */
    createFolders(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.apiGateway.fetch('POST', `${this.endpointBase}/${this.resource}/folders`, data);
        });
    }
    renameFolders(folderId, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const endpoint = `${this.endpointBase}/${this.resource}/folders/${folderId}`;
            return this.apiGateway.fetch('PUT', endpoint, data);
        });
    }
    fetchFolders(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.apiGateway.createQueryParams(options);
            const endpoint = `${this.endpointBase}/${this.resource}/folders?${queryString}`;
            if (this.cache.has(endpoint)) {
                return this.cache.get(endpoint);
            }
            const response = (yield this.apiGateway.fetch('GET', endpoint));
            this.cache.set(endpoint, response);
            return response;
        });
    }
    fetchFolderById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const endpoint = `${this.endpointBase}/${this.resource}/folders/${id}`;
            if (this.cache.has(endpoint)) {
                return this.cache.get(endpoint);
            }
            const response = (yield this.apiGateway.fetch('GET', endpoint));
            this.cache.set(endpoint, response);
            return response;
        });
    }
    fetchResourceFromFolder(folderId, options, noCache) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.apiGateway.createQueryParams(options);
            const endpoint = `${this.endpointBase}/${this.resource}/folders/${folderId}/resources?${queryString}`;
            if (this.cache.has(endpoint) && !noCache) {
                return this.cache.get(endpoint);
            }
            const response = (yield this.apiGateway.fetch('GET', endpoint));
            this.cache.set(endpoint, response);
            return response;
        });
    }
    fetchAssets(assetType, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.apiGateway.createQueryParams(options);
            const endpoint = `${this.endpointBase}/${this.resource}/${assetType}?${queryString}`;
            if (this.cache.has(endpoint)) {
                return this.cache.get(endpoint);
            }
            const response = (yield this.apiGateway.fetch('GET', endpoint));
            this.cache.set(endpoint, response);
            return response;
        });
    }
    fetchGroups() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const endpoint = `${this.endpointBase}/groups`;
            if (this.cache.has(endpoint)) {
                return this.cache.get(endpoint);
            }
            const response = (yield this.apiGateway.fetch('GET', endpoint));
            this.cache.set(endpoint, response);
            return response;
        });
    }
    addAsset(assetType, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const endpoint = `${this.endpointBase}/${this.resource}/${assetType}`;
            return this.apiGateway.fetch('POST', endpoint, JSON.stringify(payload));
        });
    }
    search(assetType, query, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.apiGateway.createQueryParams(Object.assign(Object.assign({}, options), { q: query }));
            const endpoint = `${this.endpointBase}/${this.resource}/${assetType}?${queryString}`;
            return (yield this.apiGateway.fetch('GET', endpoint));
        });
    }
};
AssetService = tslib_1.__decorate([
    (0, inversify_1.injectable)(),
    tslib_1.__param(1, (0, inversify_1.inject)(ui_core_api_gateway_1.TYPES.ApiGateway)),
    tslib_1.__metadata("design:paramtypes", [String, ui_core_api_gateway_1.ApiGateway])
], AssetService);
let WorkspaceAssetsService = class WorkspaceAssetsService extends AssetService {
    constructor(apiGateway) {
        super(assets_interfaces_1.ResourceCollection.WORKSPACE, apiGateway);
        this.resource = assets_interfaces_1.ResourceCollection.WORKSPACE;
    }
};
exports.WorkspaceAssetsService = WorkspaceAssetsService;
exports.WorkspaceAssetsService = WorkspaceAssetsService = tslib_1.__decorate([
    (0, inversify_1.injectable)(),
    tslib_1.__param(0, (0, inversify_1.inject)(ui_core_api_gateway_1.TYPES.ApiGateway)),
    tslib_1.__metadata("design:paramtypes", [ui_core_api_gateway_1.ApiGateway])
], WorkspaceAssetsService);
let UserAssetsService = class UserAssetsService extends AssetService {
    constructor(apiGateway) {
        super(assets_interfaces_1.ResourceCollection.USER, apiGateway);
        this.resource = assets_interfaces_1.ResourceCollection.USER;
    }
};
exports.UserAssetsService = UserAssetsService;
exports.UserAssetsService = UserAssetsService = tslib_1.__decorate([
    (0, inversify_1.injectable)(),
    tslib_1.__param(0, (0, inversify_1.inject)(ui_core_api_gateway_1.TYPES.ApiGateway)),
    tslib_1.__metadata("design:paramtypes", [ui_core_api_gateway_1.ApiGateway])
], UserAssetsService);
//# sourceMappingURL=assets.service.js.map